import { ScoopText, ScoopButton, ScoopRow, ScoopColumn, ScoopChip } from '../../../../../../ui'
import { formatDateTime } from '../../../../utils/formatDate'
import styles from './ReportHeader.module.scss'

// NOTE: `overallConfidence` was deliberately dropped from this header. The engine
// removed confidence in v2.9.33 ("not statistically backed"); group reports
// hardcode 0.0, which used to render here as a red "Confidence: 0%" bar (audit F2).
export const ReportHeader = ({
    title,
    entityType,
    status,
    timestamp,
    onGenerateDocx,
    isGeneratingDocx,
    disableDocx,
    titleAccessory,
}) => {
    return (
        <div className={styles.reportHeader}>
            <ScoopColumn className={styles.reportHeaderInfo}>
                <div className={styles.titleRow}>
                    <ScoopText className={styles.reportTitle}>
                        {title || 'Investigation Report'}
                    </ScoopText>
                    {titleAccessory}
                </div>
                <ScoopRow className={styles.reportMeta}>
                    {status && (
                        <ScoopChip
                            size="small"
                            color={status === 'SUCCESS' ? 'success' : 'default'}
                            label={status}
                        />
                    )}
                    {/* entityType is metadata, not a state — plain text, never a
                        brand-primary chip (review D19). */}
                    {entityType && <ScoopText className={styles.metaText}>{entityType}</ScoopText>}
                    {timestamp && (
                        <ScoopText className={styles.metaText}>{formatDateTime(timestamp)}</ScoopText>
                    )}
                </ScoopRow>
            </ScoopColumn>
            {onGenerateDocx && (
                <ScoopButton
                    variant="default"
                    size="sm"
                    onClick={onGenerateDocx}
                    loading={isGeneratingDocx}
                    disabled={disableDocx}
                >
                    Download DOCX
                </ScoopButton>
            )}
        </div>
    )
}
